/* eslint-disable no-debugger */

import { takeLatest, put, all, call } from "redux-saga/effects";

import { encryptData } from "../../_common/enode-decode";
import {
  fetchRpcNonReport,
  fetchRpcNonReportCampaign,
  ComonExportPage,
} from "./rpcNonReport.service";
import {
  listRpcNonReportCampaignChanged,
  listRpcNonReportCampaignFailure,
  listRpcNonReportCampaignSuccess,
  listRpcNonReportChanged,
  listRpcNonReportExportChanged,
  listRpcNonReportExportFailure,
  listRpcNonReportExportSuccess,
  listRpcNonReportFailure,
  listRpcNonReportSuccess,
} from "./rpcNonReport.action";
import RpcNonReportTypes from "./rpcNonReport.types";

/*****************RPC NON RESPONSE START ******************** */

export function* RpcNonResponseList({ payload }: any) {
  const key: any = "RPCReportKey";
  try {
    const {
      YearCredentials,
      MonthCredentials,
      FromDate,
      ToDate,
      Dispositon,
      PhoneNumber,
      agentCred,
      DiallingMode,
      CallOutcome,
      CampaignName,
      ResponseType,
      CompanyID,
      InstanceName,
    } = payload;

    const jsonData: any = {
      AgentID: agentCred.agentID,
      Dispositon: Dispositon,
      CallOutcome: CallOutcome,
      PhoneNumber: PhoneNumber,
      CampaignName: CampaignName,
      ModeOfDialling: DiallingMode,
      Year: YearCredentials.value,
      Month: MonthCredentials.value,
      FromDate: FromDate,
      ToDate: ToDate,
      ResponseType: ResponseType,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchRpcNonReport, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(listRpcNonReportFailure(responseData.data));
    } else {
      yield put(listRpcNonReportSuccess(responseData.data));
    }
  } catch (error) {
    yield put(listRpcNonReportFailure(error));
  }
}
export function* rpcNonResponseListReset() {
  yield put(listRpcNonReportChanged());
}
export function* onlistRpcNonResponse() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_LIST_START,
    RpcNonResponseList,
  );
}
export function* onRpcNonResponseReset() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_LIST_RESET_START,
    rpcNonResponseListReset,
  );
}

/** *********************** RPC NON RESPONSE END  ************************ */

/*****************RPC NON REPORT CAMPAIGN START ******************** */

export function* RpcNonReportCampaignList({ payload }: any) {
  const key: any = "FetchRPCReportCampaignKey";
  try {
    const { CompanyID, InstanceName } = payload;
    const jsonData: any = {
      CompanyID: CompanyID,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchRpcNonReportCampaign, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(listRpcNonReportCampaignFailure(responseData.data));
    } else {
      yield put(listRpcNonReportCampaignSuccess(responseData.data));
    }
  } catch (error) {
    yield put(listRpcNonReportCampaignFailure(error));
  }
}
export function* rpcNonReportCampaignReset() {
  yield put(listRpcNonReportCampaignChanged());
}
export function* onlistRpcNonReportCampaign() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_START,
    RpcNonReportCampaignList,
  );
}
export function* onRpcNonReportCampaignReset() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_CAMPAIGN_RESET_START,
    rpcNonReportCampaignReset,
  );
}
/*****************RPC NON REPORT CAMPAIGN START ******************** */

/** *********************** SATRT TCN RESPONSE EXPORT  LIST ************************ */

export function* rpcNonReportListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const {
      BranchID,
      IsFresh,
      ConditionExec,
      CreateDateTime,
      RequestReportPage,
      CompanyID,
      RequestedBy,
      URL,
      FromDate,
      ToDate,
      DateType,
      MemberID,
      InstanceName,
    } = payload;
    const jsonData: any = {
      BranchID: BranchID,
      IsFresh: IsFresh,
      ConditionExec: ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: CreateDateTime,
      RequestReportPage: RequestReportPage,
      CompanyID: CompanyID,
      RequestedBy: RequestedBy,
      URL: URL,
      FromDate: FromDate,
      ToDate: ToDate,
      MemberID: MemberID,
      DateType: DateType,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(listRpcNonReportExportFailure(responseData.data));
    } else {
      yield put(listRpcNonReportExportSuccess(responseData.data));
    }
  } catch (error) {
    yield put(listRpcNonReportExportFailure(error));
  }
}
export function* rpcNonReportExportAllReset() {
  yield put(listRpcNonReportExportChanged());
}
export function* onlistRpcNonReportExport() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_EXPORT_START,
    rpcNonReportListExport,
  );
}
export function* onRpcNonReportExportReset() {
  yield takeLatest(
    RpcNonReportTypes.RPC_NON_REPORT_EXPORT_RESET_START,
    rpcNonReportExportAllReset,
  );
}
/************************* END TCN RESPONSE EXPORT ALL  LIST ************************ */

export function* rpcNonReportSaga() {
  yield all([
    call(onRpcNonResponseReset),
    call(onlistRpcNonResponse),
    call(onlistRpcNonReportCampaign),
    call(onRpcNonReportCampaignReset),
    call(onlistRpcNonReportExport),
    call(onRpcNonReportExportReset),
  ]);
}
